/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PolicyBuild } from './PolicyBuild';

export type InlinePolicyVersion = {
    uuid: string;
    version: string;
    status: InlinePolicyVersion.status;
    added_at: string;
    builds: Array<PolicyBuild>;
}

export namespace InlinePolicyVersion {

    export enum status {
        DRAFT = 'draft',
        PENDING = 'pending',
        APPROVED = 'approved',
    }


}
